import { Component, OnInit } from '@angular/core';
import { Ticker } from 'app/interfaces/ticker';
import { CryptoService } from 'app/sections/crypto/services/crypto.service';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-ticker-fundamental',
  templateUrl: './ticker-fundamental.component.html',
  styleUrls: ['./ticker-fundamental.component.scss']
})
export class TickerFundamentalComponent implements OnInit {

  private _unsubscribeAll: Subject<any> = new Subject();
  public isLoading: boolean = true;
  public tickerScore: any = null;
  constructor(public cryptoService: CryptoService) { }

  ngOnInit(): void {
    this.cryptoService.shareTicker.pipe(takeUntil(this._unsubscribeAll)).subscribe((ticker:Ticker) =>{
      if(ticker){
        this.isLoading = true;
        this.cryptoService.getCryptoOnchainFundamentals(ticker.ticker).subscribe((res)=> {
          this.tickerScore = res;
          this.isLoading = false;
        }, (err: string) => {
          if(!err.includes('NOT FOUND')){
            this.tickerScore = 'subscription required';
            this.isLoading = false;
          } else {
            this.tickerScore = null;
            this.isLoading = false;
          }
        })
      }
    });
  }

}
